export default "__VITE_ASSET__b1df563a__"